import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { MenuItem, TextField } from '@mui/material';
import { httpClient } from '@/utils/httpClient';

export interface CostCenterOption {
  id: string;
  name: string;
}

interface CostCenterSelectProps {
  value: string;
  onChange: (id: string, costCenter: CostCenterOption | undefined) => void;
}

/**
 * The cost centre a billing screen is about (credits, pricing). It loads the centres once and
 * names the chosen one back to the screen, which uses it in its dialog titles.
 */
export const CostCenterSelect: React.FC<CostCenterSelectProps> = ({ value, onChange }) => {
  const t = useTranslate();
  const [costCenters, setCostCenters] = useState<CostCenterOption[]>([]);

  useEffect(() => {
    httpClient.get<CostCenterOption[]>('/admin/cost-center/GetAllCostCenters').then(r => setCostCenters(r.data));
  }, []);

  return (
    <TextField
      select
      size="small"
      label={t('screens.billing.costCenter')}
      value={value}
      onChange={(e) => onChange(e.target.value, costCenters.find((cc) => cc.id === e.target.value))}
      sx={{ minWidth: { sm: 320 }, width: { xs: '100%', sm: 'auto' } }}
    >
      {costCenters.map(cc => <MenuItem key={cc.id} value={cc.id}>{cc.name}</MenuItem>)}
    </TextField>
  );
};
